<template>
  <RcModal
    :id="modalId"
    contentClass="rc-modal-form rc-modal-permalink"
    hideFooter
    @show="onShow"
  >
    <template #modal-title>
      {{ $t("common.permalink") }}
    </template>

    <!-- shared link-->
    <template #modal-body>
      <div>
        <div class="rc-input-btn-wrapper">
          <label for="linkInput" class="visually-hidden">{{
            $t("common.link")
          }}</label>
          <input
            id="linkInput"
            type="text"
            :value="form.link"
            disabled="disabled"
            class="form-control form-control-lg"
            aria-describedby="linkInput_desc"
          /><button class="btn btn-danger btn-sm" @click="copyLink(form.link)">
            {{ $t("common.copy") }}
          </button>
        </div>
        <small id="linkInput_desc" class="form-text text-secondary">{{
          helpText
        }}</small>
      </div>
    </template>
  </RcModal>
</template>

<script>
import Config from "#/config";
import { playlistsMixin } from "@/libvue/apps/catalog/playlists/mixins";
import RcModal from "@/libvue/components/modal/Modal.vue";

export default {
  name: "RcSharingModalDetail",
  components: {
    RcModal
  },

  mixins: [playlistsMixin],
  props: {
    helpText: {
      type: String,
      required: false,
      default: ""
    }
  },

  data() {
    return {
      modalId: "sharingModalDetail",

      config: Config,
      form: {
        name: "",
        link: ""
      }
    };
  },
  methods: {
    onShow() {
      this.form.link = this.getSharedLink();
    },
    getSharedLink() {
      let route = this.$router.resolve({
        name: "catalog.item.detail",
        params: { uid: this.$route.params.uid, locale: this.$i18n.locale }
      });

      const host = Config.apiHost() ? Config.apiHost() : window.location.origin;
      return `${host}${route.href}`;
    }
  }
};
</script>
